import { APP_BASE_HREF } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfiguration } from '../models/app-configuration';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  public appConfiguration: AppConfiguration;
  private httpClient: HttpClient;

  get config() {
    return this.appConfiguration;
  }

  constructor(
    private handler: HttpBackend,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.httpClient = new HttpClient(this.handler);
  }

  loadAppConfig() {

    this.loadFile('app/app-config.json')
      .toPromise()
      .then((config) => {
        this.appConfiguration = config as AppConfiguration;
      })
      .catch((e) =>
        console.error(
          'Error fetching config data, please run npm run start to generate config files'
        )
      );
  }
  loadFile(filePath: string) {
    let baseHref = this.baseHref;
    if (!baseHref.endsWith('/')) {
      baseHref = baseHref + '/';
    }
    return this.httpClient.get(`${baseHref}assets/config/${filePath}`, { params: { d: new Date().getTime().toString() } });
  }
}
